/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var TurnoverRange;

(function (TurnoverRange) {
  TurnoverRange["BAND_0000K_0100K"] = "BAND_0000K_0100K";
  TurnoverRange["BAND_0100K_0150K"] = "BAND_0100K_0150K";
  TurnoverRange["BAND_0100K_0250K"] = "BAND_0100K_0250K";
  TurnoverRange["BAND_0150K_0200K"] = "BAND_0150K_0200K";
  TurnoverRange["BAND_0200K_0300K"] = "BAND_0200K_0300K";
  TurnoverRange["BAND_0300K_0400K"] = "BAND_0300K_0400K";
  TurnoverRange["BAND_0400K_0500K"] = "BAND_0400K_0500K";
  TurnoverRange["BAND_1000K_1500K"] = "BAND_1000K_1500K";
  TurnoverRange["BAND_0000K_0050K"] = "BAND_0000K_0050K";
  TurnoverRange["BAND_0050K_0100K"] = "BAND_0050K_0100K";
  TurnoverRange["BAND_0050K_0150K"] = "BAND_0050K_0150K";
  TurnoverRange["BAND_0150K_0250K"] = "BAND_0150K_0250K";
  TurnoverRange["BAND_0250K_0500K"] = "BAND_0250K_0500K";
  TurnoverRange["BAND_1500K_2000K"] = "BAND_1500K_2000K";
  TurnoverRange["BAND_2000K_2500K"] = "BAND_2000K_2500K";
  TurnoverRange["BAND_0500K_0750K"] = "BAND_0500K_0750K";
  TurnoverRange["BAND_0750K_1000K"] = "BAND_0750K_1000K";
  TurnoverRange["BAND_1000K_2000K"] = "BAND_1000K_2000K";
  TurnoverRange["BAND_2500K_9999K"] = "BAND_2500K_9999K";
  TurnoverRange["BAND_0500K_9999K"] = "BAND_0500K_9999K";
  TurnoverRange["BAND_2000K_9999K"] = "BAND_2000K_9999K";
  TurnoverRange["BAND_0000K_0025K"] = "BAND_0000K_0025K";
  TurnoverRange["BAND_0025K_0050K"] = "BAND_0025K_0050K";
  TurnoverRange["BAND_0050K_0075K"] = "BAND_0050K_0075K";
  TurnoverRange["BAND_0075K_0100K"] = "BAND_0075K_0100K";
})(TurnoverRange || (TurnoverRange = {}));